/// <amd-module name="InstantSearch/Shared/Services/ExecuteSearchService" />

import { ITfsSearchQuery } from "Tfs/Platform/Search";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { ISearchProvider, ISearchQuery, IVssSearchService } from "VSS/Platform/Search";

export interface IExecuteSearchService extends IVssService {
    executeSearch(
        queryText: string,
        searchProviderId?: string,
        entityType?: string,
        openInNewWindow?: boolean,
        callbackBeforeExecute?: () => void
    ): void;
}

/**
 * Service to execute search query and redirect to search portal
 */
class ExecuteSearchService extends VssService implements IExecuteSearchService {
    public executeSearch(
        queryText: string,
        searchProviderId?: string,
        entityType?: string,
        openInNewWindow?: boolean,
        callbackBeforeExecute?: () => void
    ): void {
        if (queryText) {
            const searchService = this.pageContext.getService<IVssSearchService>("IVssSearchService");
            const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
            const providerId = searchProviderId ? searchProviderId : searchService.getSelectedProvider();

            if (providerId) {
                const type = entityType;
                const searchQuery: ISearchQuery = type
                    ? ({ providerId, queryText, openInNewWindow, type } as ITfsSearchQuery)
                    : { providerId, queryText, openInNewWindow };

                contributionService.getService<ISearchProvider>(providerId).then(
                    (searchProvider: ISearchProvider) => {
                        const finalSearchQuery: ISearchQuery =
                            searchProvider && searchProvider.getQuery ? searchProvider.getQuery(searchQuery) : searchQuery;

                        this._executeSearchAndCallback(searchService, finalSearchQuery, callbackBeforeExecute);
                    },
                    (error: Error) => {
                        // If provider is not found, generate search query with basic required parmeters
                        this._executeSearchAndCallback(searchService, searchQuery, callbackBeforeExecute);
                    }
                );
            }
        }
    }

    private _executeSearchAndCallback(searchService: IVssSearchService, searchQuery: ISearchQuery, callbackBeforeExecute?: () => void): void {
        if (callbackBeforeExecute) {
            callbackBeforeExecute();
        }

        searchService.execute(searchQuery);
    }
}

Services.add("IExecuteSearchService", { serviceFactory: ExecuteSearchService });
